(() => {
  const SELECTOR = '[data-hindi-mobile-carousel]';
  const MOBILE_QUERY = '(max-width: 749px)';

  class HindiMobileCarousel {
    constructor(root) {
      if (!root || root.dataset.hindiMobileCarouselReady === 'true') return;

      this.root = root;
      this.track = root.querySelector('[data-hindi-mobile-carousel-track]');
      this.items = Array.from(root.querySelectorAll('[data-hindi-mobile-carousel-item]'));
      this.prevButton = root.querySelector('[data-hindi-mobile-carousel-prev]');
      this.nextButton = root.querySelector('[data-hindi-mobile-carousel-next]');
      this.dots = Array.from(root.querySelectorAll('[data-hindi-mobile-carousel-dot]'));
      this.mediaQuery = window.matchMedia(MOBILE_QUERY);
      this.activeIndex = 0;
      this.frame = null;

      if (!this.track || this.items.length < 2) return;

      root.dataset.hindiMobileCarouselReady = 'true';
      this.bind();
      this.update();
    }

    bind() {
      this.onScroll = () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateFromScroll());
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      this.onResize = () => this.update();
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    getClosestIndex() {
      const trackRect = this.track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;
        const distance = Math.abs(itemCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    updateFromScroll() {
      if (!this.mediaQuery.matches) return;
      this.activeIndex = this.getClosestIndex();
      this.updateControls();
    }

    update() {
      if (!this.mediaQuery.matches) {
        this.activeIndex = 0;
        this.updateControls();
        return;
      }

      this.activeIndex = this.getClosestIndex();
      this.updateControls();
    }

    updateControls() {
      this.dots.forEach((dot, index) => {
        const isActive = index === this.activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (this.prevButton) this.prevButton.disabled = this.activeIndex <= 0;
      if (this.nextButton) this.nextButton.disabled = this.activeIndex >= this.items.length - 1;
    }

    goTo(index) {
      const safeIndex = Math.max(0, Math.min(index, this.items.length - 1));
      const item = this.items[safeIndex];
      if (!item) return;

      this.activeIndex = safeIndex;
      this.updateControls();
      item.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((root) => new HindiMobileCarousel(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
